// extracted by mini-css-extract-plugin
export default {"colorPicker":"IUN+L___ColorPicker-module__colorPicker"};